import { render, staticRenderFns } from "./kvkk-tasks.vue?vue&type=template&id=33e1d11c"
import script from "./kvkk-tasks.vue?vue&type=script&lang=js"
export * from "./kvkk-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports